'use client';

import React from 'react';
import { useWatermark } from '@/app/contexts/WatermarkContext';
import { useAdmin } from '@/lib/hooks/useAdmin';

interface WatermarkToggleButtonProps {
  className?: string;
}

export default function WatermarkToggleButton({ className = '' }: WatermarkToggleButtonProps) {
  const isAdmin = useAdmin();
  const { isVisible, toggle } = useWatermark();

  // Не показываем, если не админ
  if (!isAdmin) return null;

  return (
    <button
      data-watermark-toggle-button
      onClick={toggle}
      className={`group flex items-center justify-center p-2 bg-transparent hover:bg-[#3d3d3d] border border-transparent hover:border-[#3d3d3d] rounded-lg transition-all duration-200 cursor-pointer ${className}`}
      title={isVisible ? 'Hide watermark' : 'Show watermark'}
    >
      <svg 
        className={`w-5 h-5 transition-colors ${
          isVisible 
            ? 'text-[#3bd576]' 
            : 'text-[#8c8c8c] group-hover:text-[#3bd576]'
        }`}
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" 
        />
      </svg>
    </button>
  );
}












